import { v4 as uuidv4 } from 'uuid';
import { CreateVariant } from '../../../MasterTabsProvider';
import BarcodeGridViewPluginSettings from './BarcodeGridViewPluginSettings';
import BarcodeGridView from './BarcodeGridView';

export const BarcodeGridViewTab = (variant?: CreateVariant): ITab => {
    return {
        id: uuidv4(),
        title: 'Штрих-коды и GTIN',
        view: {
            content: BarcodeGridViewPluginSettings
                ? <BarcodeGridView isTest gridId={uuidv4()} plugin={BarcodeGridViewPluginSettings} />
                : <p> Справочник не настроен </p>
        }
    }
}

export default BarcodeGridViewTab
